import { Box, FormHelperText, TextField } from '@mui/material'
import { FunctionComponent } from 'react';

export const EmailCampaignEmployeeNameAndEmail: FunctionComponent<{ formik: any }> = ({ formik }) => {
  return (
    <Box sx={{mb:2}}>
      <TextField id='name' name='name' label='Name' type='name' fullWidth
        value={formik.values.name}
        onChange={formik.handleChange} sx={{ mt: 2 }}
        error={formik.touched.name && Boolean(formik.errors.name)}
      />
      {formik.touched.name && formik.errors.name && (
        <FormHelperText sx={{ color: "#bf3333", ml: 2 }}>{formik.errors.name}</FormHelperText>
      )}
      <TextField id='emailAddress' name='emailAddress' label='Email Address' type='emailAddress' fullWidth
        value={formik.values.emailAddress}
        onChange={formik.handleChange} sx={{ mt: 2 }}
        error={formik.touched.emailAddress && Boolean(formik.errors.emailAddress)}
      />
      {formik.touched.emailAddress && formik.errors.emailAddress && (
        <FormHelperText sx={{ color: "#bf3333", ml: 2 }}>{formik.errors.emailAddress}</FormHelperText>
      )}
    </Box>
  )
}